import script from "./detail-serivce-info-block.vue?vue&type=script&lang=ts&setup=true"
export * from "./detail-serivce-info-block.vue?vue&type=script&lang=ts&setup=true"

import "./detail-serivce-info-block.vue?vue&type=style&index=0&id=1e60da37&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e60da37"]])

export default __exports__